import { Reveal, Overline } from "@/components/Reveal";

const CHAPTERS = [
  { n: "01", title: "Search & Analytics", body: "Patentability and novelty searches, freedom-to-operate analysis, landscape mapping and trademark availability checks — we map what can be protected, and where, before you invest in filing." },
  { n: "02", title: "Drafting & Filing", body: "Provisional and complete specifications with claims engineered for enforceability — filed in India and worldwide via PCT international applications and national-phase entry." },
  { n: "03", title: "Prosecution", body: "First examination reports, office actions, hearings and oppositions — handled by our patent agents and IP attorneys, with every deadline docketed in your client portal." },
  { n: "04", title: "Grant & Beyond", body: "Grant follow-up, renewals and annuities, trademark watch, assignment and licensing — your rights maintained, valued and defended for their full term." },
];

export default function Manifesto() {
  return (
    <section id="method" data-testid="method-section" className="py-24 sm:py-32 bg-navy-900/30 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Overline>Our method</Overline>
              <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl leading-tight">
                Four chapters to a <span className="italic text-gold">defensible right.</span>
              </h2>
              <p className="text-mist mt-6 text-base leading-relaxed max-w-sm">
                Intellectual property is not paperwork. It is a narrative of ownership,
                written carefully and defended relentlessly.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-8 flex flex-col gap-20 lg:gap-28 lg:pt-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={0.05 * i}>
              <div data-testid={`method-chapter-${c.n}`} className={`flex gap-8 sm:gap-12 ${i % 2 === 1 ? "lg:ml-24" : ""}`}>
                <span className="font-serif text-6xl sm:text-8xl text-outline-gold leading-none shrink-0">{c.n}</span>
                <div className="border-l border-gold/30 pl-8">
                  <h3 className="font-serif text-2xl sm:text-3xl text-white mb-4">{c.title}</h3>
                  <p className="text-mist leading-relaxed max-w-lg">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
